import { __assign } from "tslib";
import Experiments, { ReadOnlyExperiments, } from './exports/experiments';
import { factory as biLoggerFactory } from './exports/bi';
import { create as createFedopsLogger } from './exports/fedops';
export * from './types';
/**
 * Essentials for the Viewer platform
 */
var ViewerPlatformEssentials = /** @class */ (function () {
    function ViewerPlatformEssentials(env) {
        this.env = env;
        /**
         * A Fedops Logger factory
         */
        this.createFedopsLogger = createFedopsLogger;
        /**
         * A bi Logger and Factory for more loggers
         */
        this.biLoggerFactory = biLoggerFactory;
        this.env = env;
        this.sentry = env.Sentry;
        this.experiments = new ReadOnlyExperiments({
            experiments: env.conductedExperiments,
        });
    }
    /**
     * Method for creating Essentials for an App
     * @param env
     */
    ViewerPlatformEssentials.prototype.createAppEssentials = function (env) {
        return new AppEssentials({
            env: __assign(__assign({}, env), { platformEnv: this.env }),
            essentials: this,
        });
    };
    /**
     * Method for creating Essentials for a Controller
     * @param env
     */
    ViewerPlatformEssentials.prototype.createControllerEssentials = function (env, appEssentials) {
        return new ControllerEssentials({
            // @ts-expect-error accessing TS-private field 😢
            env: __assign(__assign({}, env), { appEnv: appEssentials.env }),
            essentials: this,
            appEssentials: appEssentials,
        });
    };
    return ViewerPlatformEssentials;
}());
export { ViewerPlatformEssentials };
/**
 * Essentials for Apps within the Viewer platform
 */
var AppEssentials = /** @class */ (function () {
    function AppEssentials(_a) {
        var _this = this;
        var env = _a.env, essentials = _a.essentials;
        var _b, _c;
        /**
         * A bi Logger and Factory for more loggers
         */
        this.biLoggerFactory = function (options) {
            return _this.env.biLoggerFactory(options);
        };
        this.env = env;
        this.essentials = essentials;
        this.experiments = new ReadOnlyExperiments({
            experiments: (_c = (_b = this.env.platformEnv.appsConductedExperiments) === null || _b === void 0 ? void 0 : _b[env.appDefId]) !== null && _c !== void 0 ? _c : {},
        });
    }
    /**
     * A Sentry & Sentry Hub factory
     */
    AppEssentials.prototype.createSentryHub = function (options) {
        if (!this.essentials.sentry) {
            throw new Error('Essentials initialized without Sentry!');
        }
        var client = new this.essentials.sentry.BrowserClient(options);
        var hub = new this.essentials.sentry.Hub(client);
        return { client: client, hub: hub };
    };
    /**
     * An Experiments object factory
     */
    AppEssentials.prototype.createExperiments = function (_a) {
        var scopes = _a.scopes, _b = _a.useNewApi, useNewApi = _b === void 0 ? true : _b, requestContext = _a.requestContext;
        return new Experiments({ scopes: scopes, useNewApi: useNewApi, requestContext: requestContext });
    };
    return AppEssentials;
}());
export { AppEssentials };
/**
 * Essentials for Controllers within the Viewer platform
 */
var ControllerEssentials = /** @class */ (function () {
    function ControllerEssentials(_a) {
        var _this = this;
        var env = _a.env, essentials = _a.essentials, appEssentials = _a.appEssentials;
        /**
         * A bi Logger and Factory for more loggers
         */
        this.biLoggerFactory = function (options) {
            return _this.appEssentials.biLoggerFactory(options);
        };
        /**
         * A Sentry & Sentry Hub factory
         */
        this.createSentryHub = function (options) {
            return _this.appEssentials.createSentryHub(options);
        };
        /**
         * An Experiments object factory
         */
        this.createExperiments = function (options) {
            return _this.appEssentials.createExperiments(options);
        };
        this.env = env;
        this.essentials = essentials;
        this.appEssentials = appEssentials;
        this.fedopsLogger = this.env.appEnv.getLoggerForWidget({
            appId: this.env.appEnv.appDefId,
            widgetId: this.env.widgetId,
        });
        this.experiments = this.appEssentials.experiments;
    }
    return ControllerEssentials;
}());
export { ControllerEssentials };
//# sourceMappingURL=api.js.map